import React, { useState } from "react";
import ReactPlayer from "react-player";

import campus from "../../video/Virtual Tour.mp4";
import { Link } from "react-router-dom";
import campus1 from "../../video/Admission Template bhopal.mp4";
import "./Landing.css";
import { IoCloseOutline } from "react-icons/io5";
import { BiLoaderAlt } from "react-icons/bi";
import { GiSpeaker, GiSpeakerOff } from "react-icons/gi";
// import homeBanner1 from "../../image/home_banner/admissionbanner1.webp";
// import homeBanner2 from "../../image/home_banner/admissionbanner2.webp";
// import homeBanner3 from "../../image/home_banner/banner2.webp";
import homeBanner4 from "../../image/home_banner/Home_banner.webp";
import { Button } from "react-bootstrap";

function Landing({ video, cover }) {
  const [isMuted, setIsMuted] = useState(true);
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const openModal = (e) => {
    console.log("BUtton is clicked");
    e.stopPropagation();
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  return video ? (
    <>
      <div className="position-relative">
        {/* <ReactPlayer
        url={campus}
        loop={true}
        muted={isMuted}
        playing={true}
        controls={false}
        width="100%"
        className="landing_video"
      /> */}
        <div id="carouselExampleIndicators" data-bs-ride="carousel" className="carousel slide margin8top">
        <div>
          <div className="carousel-indicators d-none">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
            <Link to="/admissions" className="landing-admissions-banner">
              <img
                src={homeBanner4}
                className="landing-admissions-banner-image"
                alt="Student showcasing a robotics project in a STEAM classroom"
              />
              <div className="landing-admissions-banner-content">
                <h1 className="landing-admissions-banner-headline">
                  <span>Big Ideas Begin Here.</span>
                  <span className="landing-admissions-banner-highlight">
                    Future Leaders Start Here.
                  </span>
                </h1>
                <p className="landing-admissions-banner-description">
                  Discover a world of learning where academic excellence meets
                  creativity, innovation, hands-on STEAM experiences, and holistic
                  development.
                </p>
                <p className="landing-admissions-banner-grades">
                  Nursery- Grade 9 &amp; 11
                </p>
                <span className="landing-admissions-banner-cta">
                  APPLY FOR ADMISSION
                </span>
              </div>
              </Link>
            </div>
            {/* <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner2}
                width="100%"
              />
              </Link>
            </div>
            <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner3}
                width="100%"
              />
              </Link>
            </div> */}
          </div>
          <button
            className="carousel-control-prev d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      </div>
      <br />
      {/* <center>
        <button onClick={openModal} className="button-modal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-camera-reels-fill"
            viewBox="0 0 16 16"
          >
            <path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
            <path d="M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
            <path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
          </svg>
          <br />
          Virtual Tour
          {modal ? (
            <section className="modal__bg">
              <div className="modal__align">
                <div className="modal__content" modal={modal}>
                  <IoCloseOutline
                    className="modal__close"
                    arial-label="Close modal"
                    onClick={setModal}
                  />
                  <div className="modal__video-align">
                    {videoLoading ? (
                      <div className="modal__spinner">
                        <BiLoaderAlt
                          className="modal__spinner-style"
                          fadeIn="none"
                        />
                      </div>
                    ) : null}

                    <iframe
                      className="modal__video-style"
                      onLoad={spinner}
                      loading="lazy"
                      width="800"
                      height="500"
                      src="https://www.youtube.com/embed/Ouq-edZzDZg?si=dpuWXlaweRhe84Dp"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </section>
          ) : null}
        </button>
      </center> */}
    </>
  ) : (
    <div className="cover_img_cont">
      <img src={cover} alt="images" className="cover_img" />
    </div>
  );
}

export default Landing;
